import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';

export default function BuildoutModal({ className, centered = true, ...props }) {
  return (
    <Modal
      centered={centered}
      className={className}
      {...props}
    />
  );
}

BuildoutModal.propTypes = {
  centered: PropTypes.bool,
  className: PropTypes.string,
  fullscreen: PropTypes.string,
  size: PropTypes.string
};

BuildoutModal.Body = Modal.Body;
BuildoutModal.Footer = Modal.Footer;
BuildoutModal.Header = function Header({ children, ...props }) {
  return (
    <Modal.Header {...props}>
      <Modal.Title className="fs-6">{children}</Modal.Title>
    </Modal.Header>
  );
};

BuildoutModal.Header.propTypes = {
  children: PropTypes.node,
};
